// extracted by mini-css-extract-plugin
export default {"clearfix":"clearfix--5cd2cf"};